import { lazy } from 'react'
import { Navigate, Route } from 'react-router-dom'
import { PermissionRoute } from '../mia-auth/components/PermissionRoute'
import { ProtectedRoute } from '../mia-auth/components/ProtectedRoute'
import { AppShell } from '../shared/layout/AppShell'
import { LegacyConversationBrainRedirect } from './LegacyConversationBrainRedirect'
import { LegacyConversationEngineRedirect } from './LegacyConversationEngineRedirect'

const DashboardPage = lazy(() => import('../mia-dashboard/pages/DashboardPage'))
const TenantsPage = lazy(() => import('../mia-tenants/pages/TenantsPage'))
const EnvironmentsPage = lazy(() => import('../mia-environments/pages/EnvironmentsPage'))
const ChannelsPage = lazy(() => import('../mia-channels/pages/ChannelsPage'))
const SecretsPage = lazy(() => import('../mia-secrets/pages/SecretsPage'))
const UsersPage = lazy(() => import('../mia-users/pages/UsersPage'))
const RolesPage = lazy(() => import('../mia-roles/pages/RolesPage'))
const CatalogPage = lazy(() => import('../mia-catalog/pages/CatalogPage'))
const AgentBrainPlatformPage = lazy(() => import('../mia-agent-brain/pages/AgentBrainPlatformPage'))
const AgentsPage = lazy(() => import('../mia-agents/pages/AgentsPage'))
const TokensPage = lazy(() => import('../mia-token-management/pages/TokensPage'))
const ProvidersPage = lazy(() => import('../mia-ai-providers/pages/ProvidersPage'))
const ProviderModelsPage = lazy(() => import('../mia-ai-providers/pages/ProviderModelsPage'))
const RoutesPage = lazy(() => import('../mia-api-routes/pages/RoutesPage'))
const SessionsPage = lazy(() => import('../mia-sessions/pages/SessionsPage'))
const CheckoutPage = lazy(() => import('../mia-checkout/pages/CheckoutPage'))
const ConfigurationsPage = lazy(() => import('../mia-configurations/pages/ConfigurationsPage'))
const FeatureFlagsPage = lazy(() => import('../mia-feature-flags/pages/FeatureFlagsPage'))
const AuditPage = lazy(() => import('../mia-audit/pages/AuditPage'))
const SecurityPage = lazy(() => import('../mia-security/pages/SecurityPage'))
const PublicSettingsPage = lazy(() => import('../mia-public-settings/pages/PublicSettingsPage'))
const APIKeysPage = lazy(() => import('../mia-api-keys/pages/APIKeysPage'))
const TryOnAssetsPage = lazy(() => import('../mia-tryon-assets/pages/TryOnAssetsPage'))
const ApparelTryOnPage = lazy(() => import('../mia-tryon-apparel/pages/ApparelTryOnPage'))
const IntegrationsPage = lazy(() => import('../mia-integrations/pages/IntegrationsPage'))
const DeletedResourcesPage = lazy(() => import('../mia-resource-lifecycle/pages/DeletedResourcesPage'))
const ProspectSDRRoutes = lazy(() => import('../mia-prospect-sdr/routes/ProspectSDRRoutes'))
const WhatsAppFlowRoutes = lazy(() => import('../mia-whatsapp-flow/routes/WhatsAppFlowRoutes'))
const BrainOperationalPage = lazy(() => import('../mia-brain-operational/pages/BrainOperationalPage'))
const MiaEveryStylesPage = lazy(() => import('../mia-applications/pages/MiaEveryStylesPage'))

export function AdminRoutes() {
  return <Route path="admin" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
    <Route index element={<DashboardPage />} />
    <Route path="tenants" element={<TenantsPage />} />
    <Route path="environments" element={<EnvironmentsPage />} />
    <Route path="channels" element={<ChannelsPage />} />
    <Route path="secrets" element={<SecretsPage />} />
    <Route path="users" element={<PermissionRoute permission="users.read"><UsersPage /></PermissionRoute>} />
    <Route path="roles" element={<PermissionRoute permission="roles.read"><RolesPage /></PermissionRoute>} />
    <Route path="catalog" element={<CatalogPage />} />
    <Route path="brain-operational" element={<BrainOperationalPage />} />
    <Route path="brain" element={<AgentBrainPlatformPage />} />
    <Route path="conversation-engine" element={<LegacyConversationEngineRedirect />} />
    <Route path="conversation-engine/products/:productId" element={<LegacyConversationEngineRedirect />} />
    <Route path="applications/mia-every-styles" element={<MiaEveryStylesPage />} />
    <Route path="conversation-brain/*" element={<LegacyConversationBrainRedirect />} />
    <Route path="tryon-assets" element={<TryOnAssetsPage />} />
    <Route path="apparel-tryon" element={<ApparelTryOnPage />} />
    <Route path="agents" element={<AgentsPage />} />
    <Route path="agents/:agentId" element={<AgentsPage />} />
    <Route path="tokens" element={<TokensPage />} />
    <Route path="providers" element={<ProvidersPage />} />
    <Route path="providers/models" element={<ProviderModelsPage />} />
    <Route path="routes" element={<RoutesPage />} />
    <Route path="sessions" element={<SessionsPage />} />
    <Route path="checkout" element={<CheckoutPage />} />
    <Route path="public-settings" element={<PublicSettingsPage />} />
    <Route path="api-keys" element={<APIKeysPage />} />
    <Route path="integrations" element={<IntegrationsPage />} />
    <Route path="configurations" element={<ConfigurationsPage />} />
    <Route path="prospect-sdr/*" element={<ProspectSDRRoutes />} />
    <Route path="whatsapp-flow/*" element={<WhatsAppFlowRoutes />} />
    <Route path="deleted-resources" element={<DeletedResourcesPage />} />
    <Route path="feature-flags" element={<FeatureFlagsPage />} />
    <Route path="audit" element={<AuditPage />} />
    <Route path="security" element={<SecurityPage />} />
    <Route path="*" element={<Navigate to="/admin" replace />} />
  </Route>
}
